var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding"},[_c('AppForm',{attrs:{"wlc":_vm.wlc,"csrf":_vm.csrf},on:{"domain-changed":_vm.domainChanged}}),_vm._v(" "),_c('AppContent',{attrs:{"domain":_vm.domain}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }